module.exports = __webpack_public_path__ + "img/cupcake.be5030ca.webp";